<template>
    <div
        :id="`activity-${log.id}`"
        v-tooltip="{ message: log.user ? log.user.name : '', position: 'top-left' }"
        class="activity-preview"
    >
        <div class="activity-preview__avatar">
            <!-- eslint-disable -->
            <div v-if="log.user" v-html="log.user.avatar"></div>
            <!-- eslint-enable -->

            <div class="activity-preview__badge" :class="badgeModifierClass">
                <template v-if="log.type === 'warning' || log.type === 'update'">
                    <Icon
                        icon="hero/outline/information-circle"
                        class="activity-preview__badge-icon activity-preview__badge-icon--warning"
                    />
                </template>
                <template v-else-if="log.type === 'add' || log.type === 'create'">
                    <Icon
                        icon="hero/outline/plus-circle"
                        class="activity-preview__badge-icon activity-preview__badge-icon--success"
                    />
                </template>
                <template v-else-if="log.type === 'delete'">
                    <Icon
                        icon="hero/outline/minus-circle"
                        class="activity-preview__badge-icon activity-preview__badge-icon--danger"
                    />
                </template>
                <template v-else>
                    <Icon
                        icon="hero/outline/bars-3-bottom-left"
                        class="activity-preview__badge-icon activity-preview__badge-icon--small activity-preview__badge-icon--muted"
                    />
                </template>
            </div>
        </div>
        <div class="activity-preview__content">
            <div class="activity-preview__action">{{ log.action }}</div>
            <!-- eslint-disable -->
            <div v-if="log.subject && log.subject.text" v-html="log.subject.text"></div>
            <!-- eslint-enable -->
            <div class="activity-preview__time">{{ log.time }}</div>
        </div>
        <div class="activity-preview__timestamp">
            {{ dateTimeHumanReadableFromISO(log.created_at) }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { toRef, computed } from 'vue';
import { LogActivity } from '@src/Logging/Pages/types';
import { dateTimeHumanReadableFromISO } from '@src/Common/Helpers/dates';

const props = defineProps<{
    log: LogActivity;
}>();

const log = toRef(props, 'log');

const badgeModifierClass = computed(() => {
    switch (log.value.type) {
        case 'add':
        case 'create':
            return 'activity-preview__badge--add';
        case 'delete':
            return 'activity-preview__badge--delete';
        case 'warning':
        case 'update':
            return 'activity-preview__badge--warning';
        default:
            return 'activity-preview__badge--line';
    }
});
</script>
